module.exports = __webpack_public_path__ + "img/right0_active.3e355e1f.svg";